<div
  class="d-flex align-items-center justify-content-center flex-column error-page vh-50">
  <div class="motif-display-2-light mb-5 pb-2">(o_o)</div>
  <h1 class="motif-h2-default-light mb-2">Something went wrong!</h1>
  <p class="motif-body1-default-light mb-5 pb-2">Please try again later</p>
  <!-- <app-sa-button
    labelText="Navigate to Home"
    [severity]="'primary'"
    (buttonClick)="navigateHome()" /> -->
    <button motifButton color="primary" size="small" (click)="navigateHome()" aria-label="Navigate to Home">
      Navigate to Home
    </button>
</div>
